import src from "IMAGE";
export default { src, width: 993, height: 556, blurWidth: 0, blurHeight: 0};
